import { createSlice } from "@reduxjs/toolkit";

// Orden llega a veces como texto. Sin pasarlo a numero, "9" gana a "10"
// y al sumar 1 se concatena ("91") en vez de seguir la secuencia.
const aNumero = (valor) => {
    const n = typeof valor === "number" ? valor : parseInt(valor, 10);
    return Number.isFinite(n) ? n : 0;
};

const maxOrdenDe = (filas) => (filas || []).reduce((mayor, item) => {
    const n = aNumero(item && item.orden);
    return n > mayor ? n : mayor;
}, 0);

const initialState = {
    defaultEntity: [{
        id: 0,
        numero: 0,
        idModelo: 0,
        codigoModelo: "",
        modelo: "",
        idArea: 0,
        codigoArea: "",
        area: "",
        // La primera fila de un plan nuevo ya sale con Orden 1: el campo se
        // genera solo y no hay que escribirlo.
        orden: 1,
        idPuntuacionGrupo: null,
        puntuacionGrupo: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,

        modeloArea: [],
    }],
    entity: [{
        id: 0,
        numero: 0,
        idModelo: 0,
        codigoModelo: "",
        modelo: "",
        idArea: 0,
        codigoArea: "",
        area: "",
        orden: 1,
        idPuntuacionGrupo: null,
        puntuacionGrupo: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,

        modeloArea: [],
    }],
    // Ultimo orden ya generado en este plan. Al agregar se suma uno, y borrar
    // una fila no lo baja: el siguiente no reutiliza un orden que ya salio.
    ultimoOrden: 1,
    listModelo: [{id: 0, codigo: "", nombre: "", descripcion: ""}],
    validationActive: {
      AtLeastOneRow: false,
    },
    validationMessage: [],
}

export const therapyPlanAreaSlice = createSlice({
    name: "therapyPlanArea",
    initialState,
    reducers: {
      setEntity: (state, action) => {
        // El detalle se muestra en el orden que dio el terapeuta: el campo
        // Orden de cada fila manda. A igual orden se sigue modelo y area para
        // que el listado no cambie entre recargas.
        const rows = Array.isArray(action.payload) ? action.payload : [action.payload];

        state.entity = rows
            .slice()
            .sort((a, b) => {
                const oa = aNumero(a.orden);
                const ob = aNumero(b.orden);
                if (oa !== ob) return oa - ob;
                if ((a.modelo || "") !== (b.modelo || "")) return (a.modelo || "").localeCompare(b.modelo || "");
                return (a.area || "").localeCompare(b.area || "");
            });
        state.ultimoOrden = maxOrdenDe(state.entity);

        // Las areas de cada modelo NO se tocan aqui: cargarAreas las pide del
        // servidor. Antes se ponia un arreglo con un solo elemento (el area de la
        // fila) y como cargarAreas solo carga cuando el arreglo esta vacio, el
        // listado del autocompletado nunca mostraba las demas areas del modelo.
      },
      setData: (state, action) => {
        var { numero, name, value } = action.payload;

        // Los campos id/orden/valor se guardan como numero. Un null se
        // respeta tal cual (parseInt(null) da NaN y el desplegable se queda
        // sin seleccionar): pasa al elegir "(Seleccione)" en el grupo de
        // puntuacion del detalle del plan.
        if (value !== null && (name.startsWith("id") || name.startsWith("orden") || name.startsWith("valor"))) {
            const n = parseInt(value, 10);
            value = name.startsWith("orden") && !Number.isFinite(n) ? 0 : n;
        }

        const index = state.entity.findIndex(item => item.numero === numero);
        state.entity[index][name] = value;

        if (name.startsWith("orden") && aNumero(value) > aNumero(state.ultimoOrden)) {
            state.ultimoOrden = aNumero(value);
        }

        Object.keys(state.validationActive).forEach(function (key) {
            state.validationActive[key] = true;
        })
      },
      add: (state, action) => {
        var maxNumero = state.entity.length === 0 ? 0 : Math.max.apply(null, state.entity.map((item) => { return item.numero; }))

        // Siempre el ultimo orden generado mas uno, no el maximo de las filas
        // que siguen en pantalla: si se borro la de mayor orden, no se repite.
        var orden = Math.max(aNumero(state.ultimoOrden), maxOrdenDe(state.entity)) + 1;
        state.ultimoOrden = orden;

        state.entity.push(state.defaultEntity.map((item) => {
            return { ...item, numero: maxNumero + 1, orden: orden };
        })[0]);
      },
      remove: (state, action) => {
        state.entity = state.entity.filter(item => item.numero !== action.payload)
      },
      setListModelo: (state, action) => {
        state.listModelo = action.payload;
      },
      setValidations: (state, action) => {
        state.validationMessage = action.payload;
      },
      activeValidations: (state, action) => {
        Object.keys(state.validationActive).forEach(function (key) {
            state.validationActive[key] = true;
        })
      },
    },
  });
  
  export const { setEntity, setData, add, remove
    , setListModelo
    , setValidations, activeValidations } = therapyPlanAreaSlice.actions;
  export default therapyPlanAreaSlice.reducer;
  